import request from '../config/axios-config';

export function login(email, password) {
    return (
        request({
            method: 'post',
            url: '/login',
            data: {email: email, password: password,}
        })
    )
}

export function changePassword(oldPassword, newPassword) {
    return (
        request({
            method: 'post',
            url: '/user/change-password',
            data: {
                oldPassword: oldPassword,
                newPassword: newPassword
            }
        })
    )
}

export function loginFromToken() {
    return (
        request({
            method: 'get',
            url: '/login/fromToken',
        })
    )
}